import { setAutoFreeze } from 'immer';

/**
 * Immer v8 introduces breaking change that enables freezing objects even in prod https://github.com/immerjs/immer/releases/tag/v8.0.0.
 */
setAutoFreeze(process.env.NODE_ENV !== 'production');
